module.exports = __webpack_public_path__ + "static/img/arduino-placa.53b9c35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arduino-placa.svg
// module id = eBfC
// module chunks = 0